module.exports = __webpack_public_path__ + "img/chp.fa2d9f68.png";